export const Version = '2016-03-04';
export const Service = 'kec';
export const KecPath = '/kecapi/';
// export const KecPath = '/console-kec-api/';
export const source = 'kec';
const noLoginKecApi = '/noLoginKecApi/'
export const QueryProductNetworkInterfaceQuota = {
    path: KecPath,
    params: {
        Action: 'QueryProductNetworkInterfaceQuota',
        Service,
        Version,
        source
    },
    method: 'get'
}

export const ValidateIpv6Support = {
    path: KecPath,
    params: {
        Action: 'ValidateIpv6Support',
        Version,
        source,
        Service: 'kec'
    },
    method: 'get'
};

export const AllVpcInfo = {
    path: KecPath,
    params: {
        Action: 'AllVpcInfo',
        Version,
        source,
        Service: 'vpc'
    },
    method: 'get'
};

export const AdrList = {
    path: KecPath,
    params: {
        Action: 'DescribeSubnetAvailableAddresses',
        Version,
        source,
        Service: 'vpc'
    },
    method: 'get'
};
export const AllocatedAdrList = {
    path: KecPath,
    params: {
        Action: 'DescribeSubnetAllocatedIpAddresses',
        Version,
        source,
        Service: 'vpc'
    },
    method: 'get'
};

//网络控制台预留IP
export const DescribePrivateIpAddressAttributes = {
    path: KecPath,
    params: {
        Action: 'DescribePrivateIpAddressAttributes',
        Version,
        source,
        Service: 'vpc'
    },
    method: 'get'
};

export const DescribeSubnets = {
    path: KecPath,
    params: {
        Action: 'DescribeSubnets',
        Service: 'vpc',
        Version,
        source
    },
    method: 'get'
};
export const AdrCount = {
    path: KecPath,
    params: {
        Action: 'QuerySubnetAvailableAddressesCount',
        Version,
        source,
        Service: 'vpc'
    },
    method: 'get'
};

//获取支持IPV6的机型ProductTypeId的数据
export const getIpv6SupportProductType = {
    path: KecPath,
    params: {
        Action: 'GetIpv6SupportProductType',
        Service,
        Version,
        source
    },
    method: 'post'
};
export const DescribeSecurityGroupsQuota = {
    path: KecPath,
    params: {
        Action: 'DescribeSecurityGroupsQuota',
        Version,
        Service
    },
    method: 'get'
};
//--以下为未登录service--
export const noLoginAllVpcInfo = {
    path: noLoginKecApi,
    params: {
        Action: 'AllVpcInfo',
        Version,
        source,
        Service: 'vpc'
    },
    method: 'get'
};

export const noLoginAdrList = {
    path: noLoginKecApi,
    params: {
        Action: 'DescribeSubnetAvailableAddresses',
        Version,
        source,
        Service: 'vpc'
    },
    method: 'get'
};
//--以上为未登录service--